import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  enh_action: 'remove',
  event_name: 'remove_from_bag',
  event_category: 'ecommerce',
  event_action: 'remove from bag',
  event_label: null, // '<product name> - <product ID>'
  product_id: null, // '<product id>'
  product_shade: null, // '<product shade>'
  product_size: null, // '<product size>'
  product_sku: null, // '<sku id>'
};

function trackRemoveFromCart(_: string, eventData: IDataLayer = {}) {
  // TODO: investigate why this is being pulled from the data layer before the event is fired
  // why isn't this being passed in the actual event, then added to the datalayer?
  const data = tealium.dataLayer?.data || {};
  eventData.event_label = tealium.dataLayer.formatProductEventLabel(eventData);

  let skuIndex = -1;

  if (eventData.is_pincer_cart) {
    if (eventData.product_sku?.length) {
      skuIndex = data.cart_product_sku?.indexOf(eventData.product_sku[0]);
    }
  } else if (eventData.product_code?.length) {
    skuIndex = data.cart_product_product_code?.indexOf(
      eventData.product_code[0],
    );
  }

  if (skuIndex >= 0) {
    eventData.event_label = tealium.dataLayer.formatProductEventLabel({
      product_name: [data.cart_product_name[skuIndex]],
      product_id: [data.cart_product_id[skuIndex]],
    });
    eventData.product_id = [data.cart_product_id[skuIndex]];
    eventData.product_price = [data.cart_product_price[skuIndex]];
    eventData.product_product_code = [data.cart_product_product_code[skuIndex]];
    eventData.product_shade = [data.cart_product_shade[skuIndex]];
    eventData.product_size = [data.cart_product_size[skuIndex]];
    eventData.product_sku = [data.cart_product_sku[skuIndex]];
  }

  if (eventData.event_label !== '') {
    tealium.evtLink({ ...defaultData, ...eventData });
  }
}

registerAnalyticsEventHandler('removeFromCart', trackRemoveFromCart);
